export const PAY_PUP_LS_AUTH_TOKEN = "PAY_PUP_LS_AUTH_TOKEN";
export const PAY_PUP_LS_AUTH_USER_DETAILS = "PAY_PUP_LS_AUTH_USER_DETAILS";
export const PAY_PUP_LS_AUTH_USER_ID = "PAY_PUP_LS_AUTH_USER_ID";
export const PAY_PUP_LS_AUTH_USER_ROLE = "PAY_PUP_LS_AUTH_USER_ROLE";
export const PAY_PUP_LS_AGENCY_ID = "PAY_PUP_LS_AGENCY_ID";
export const PAY_PUP_ADMIN_FIRSTNAME = "PAY_PUP_ADMIN_FIRSTNAME";
export const PAY_PUP_ADMIN_LASTNAME = "PAY_PUP_ADMIN_LASTNAME";
export const PAY_PUP_ADMIN_EMAIL = "PAY_PUP_ADMIN_EMAIL";
export const PAY_PUP_ADMIN_PROFILE_IMAGE = "PAY_PUP_ADMIN_PROFILE_IMAGE";
export const PAY_PUP_ADMIN_PHONE_NUMBER = "PAY_PUP_ADMIN_PHONE_NUMBER";
export const PAY_PUP_LS_TEMPLATE_ID = "PAY_PUP_LS_TEMPLATE_ID";
export const CUSTOMER_TOKEN = "CUSTOMER_TOKEN";
export const CUSTOMER_USERID = "CUSTOMER_UESRID";
export const CUSTOMER_USERNAME = "CUSTOMER_USERNAME";
export const PAY_PUP_AGENCY_URL = "PAY_PUP_AGENCY_URL";
export const PAY_PUP_IS_ROOTUSER = "PAY_PUP_IS_ROOTUSER";
export const CUSTOMER_AGENCY_ID = "CUSTOMER_AGENCY_ID";
export const CUSTOMER_AGENCY_URL = "CUSTOMER_AGENCY_URL";
export const CUSTOMER_PAYMENT_DOG_LICENSE_ID =
  "CUSTOMER_PAYMENT_DOG_LICENSE_ID";
export const CUSTOMER_URL = "CUSTOMER_URL";
export const TTID = "TTID";
export const CUSTOMER_EMAIL = "CUSTOMER_EMAIL";
export const CUSTOMER_STATE = "CUSTOMER_STATE";
